import type { WorkItemView } from '@tasks/contracts/work-items';

/** Por ahora solo se agrupa por proyecto; añadir otro criterio es añadir una entrada aquí. */
export const GROUP_KEYS = ['project'] as const;
export type GroupKey = (typeof GROUP_KEYS)[number];

/** Lo que pinta la tabla: o una banda de grupo, o una fila del modelo. */
export type GroupedEntry<T> =
  | { kind: 'group'; id: string; label: string; count: number }
  | { kind: 'row'; id: string; row: T };

type Groupable = { id: string; original: WorkItemView };

/**
 * Reparte las filas en grupos **conservando el orden del servidor**: el primer item de cada
 * proyecto fija dónde va su banda y dentro de ella las filas siguen como llegaron. Agrupar no
 * es reordenar, así que la ordenación elegida en la barra sigue mandando dentro de cada grupo.
 *
 * Agrupa lo que hay cargado, que es lo que la tabla pinta: al traer otra página los items
 * nuevos caen en su banda, no forman otra.
 */
export const groupedRows = <T extends Groupable>(
  rows: readonly T[],
  group: GroupKey | undefined,
  projectName: (key: string) => string,
): GroupedEntry<T>[] => {
  if (group === undefined) return rows.map((row) => ({ kind: 'row', id: row.id, row }));

  const byKey = new Map<string, T[]>();
  for (const row of rows) {
    const key = row.original.projectKey;
    byKey.set(key, [...(byKey.get(key) ?? []), row]);
  }

  return [...byKey].flatMap(([key, members]): GroupedEntry<T>[] => [
    { kind: 'group', id: `grupo-${key}`, label: projectName(key), count: members.length },
    ...members.map((row): GroupedEntry<T> => ({ kind: 'row', id: row.id, row })),
  ]);
};
